import Link from "next/link";
import { FileText, Package } from "@/components/icons";
import { Button } from "@/components/ui/button";

interface ListingEmptyStateProps {
  emptyMessage: string;
  locationName?: string;
  productName?: string;
}

function buildQuoteHref(locationName?: string, productName?: string): string {
  const params = new URLSearchParams({ type: "buy" });
  if (productName) params.set("product", productName);
  if (locationName) params.set("location", locationName);
  const queryString = params.toString();
  return `/request-quote?${queryString}`;
}

export function ListingEmptyState({
  emptyMessage,
  locationName,
  productName,
}: ListingEmptyStateProps) {
  return (
    <div className="flex flex-col items-center justify-center rounded-sm border border-dashed border-border px-6 py-12 text-center bg-muted/50">
      <div className="mb-3 flex h-10 w-10 items-center justify-center rounded-sm border border-border bg-card">
        <Package className="h-4 w-4 text-muted-foreground" />
      </div>
      <h3 className="mb-1 text-sm font-medium text-foreground">
        No listings found
      </h3>
      <p className="max-w-sm text-xs text-muted-foreground">{emptyMessage}</p>

      <div className="mt-6 w-full max-w-sm border-t border-border pt-6">
        <Button variant="outline" size="sm" asChild>
          <Link href={buildQuoteHref(locationName, productName)}>
            <FileText className="h-3.5 w-3.5 mr-1.5" />
            Check availability
          </Link>
        </Button>
      </div>
    </div>
  );
}
